import { PostHogEventEnum, type AgentCreateSource } from '@/Domain/enum/PostHogEvent.enum';
import { usePostHogAnalytics } from '@/Domain/hooks/App/usePostHog/usePostHogAnalytics.hook';
import { useCreateAgentStore } from '@/Domain/store/createAgent.store';

// `/add_new_ai/` creates an agent per request and takes seconds to redirect, during which the page stays interactive.
export const useCreateAgent = (): {
  isCreating: boolean;
  createAgent: (source: AgentCreateSource) => void;
} => {
  const { capture } = usePostHogAnalytics();
  const { isCreating, startCreating } = useCreateAgentStore();

  const createAgent = (source: AgentCreateSource): void => {
    if (useCreateAgentStore.getState().isCreating) return;
    startCreating();
    // Capture before the hard nav; posthog flushes its queue on pagehide via sendBeacon.
    capture(PostHogEventEnum.AgentCreateClicked, { source });
    window.location.replace('/add_new_ai/');
  };

  return { isCreating, createAgent };
};
